import { FaUser, FaUsers, FaMountain } from 'react-icons/fa';
import images from './images';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaUser />,
    title: 'Solo Traveler',
    content: 'Perfect for individual explorers',
    price: 299.00,
    features: [
      'Access to All Guided Tours',
      'Complimentary Travel Insurance',
      'Free Airport Pickup',
      '1 Local Experience Included',
      '24/7 Travel Support',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaUsers />,
    title: 'Family Getaway',
    content: 'Ideal for family adventures',
    price: 599.00,
    features: [
      'Tour Access for Up to 4 People',
      'Kid-Friendly Activities',
      'Free Travel Insurance for Family',
      '2 Local Experiences Included',
      'Priority Support & Booking',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaMountain />,
    title: 'Luxury Escape',
    content: 'Premium unforgettable journeys',
    price: 1199.00,
    features: [
      'All-Inclusive Luxury Tours',
      'Private Guide & Chauffeur',
      'Luxury Accommodation Included',
      'VIP Lounge Access',
      'Custom Itinerary Planning',
    ],
  },
];

export default pricing;